import React, { ReactNode } from "react";
import AppSlideFadeIn from "../../Generic/AppSlideFadeIn";
import { VisitsTab } from "../MainTypes";
import VisitsTabs from "./VisitsTabs";

interface Props {
  activeTab: VisitsTab;
  availableOptions: ReactNode;
  scheduleOptions: ReactNode;
  showAvailableVisitHeader: boolean;
  setActiveTab: (tab: VisitsTab) => void;
}

const VisitsExtraHeader = (props: Props) => {
  return (
    <div className="VisitsExtraHeader">
      <VisitsTabs activeTab={props.activeTab} onClick={props.setActiveTab} />
      {props.showAvailableVisitHeader ? (
        <div hidden={props.activeTab !== "Available"}>
          <AppSlideFadeIn>{props.availableOptions}</AppSlideFadeIn>
        </div>
      ) : null}

      <div hidden={props.activeTab !== "Schedule"}>
        <AppSlideFadeIn>{props.scheduleOptions}</AppSlideFadeIn>
      </div>
    </div>
  );
};

export default VisitsExtraHeader;
